import { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getReservationStatusApi } from "../../api/api";
import RIcon from "./components/ReservasIcons";
import {
	getReservationKind,
	readStoredReservation,
} from "./reservationOutcome";
import "./reservas.css";

const ReservaCancel = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const stored = useMemo(() => readStoredReservation(), []);
	const [statusInfo, setStatusInfo] = useState(null);
	const [statusLoaded, setStatusLoaded] = useState(false);

	const reservationCode = useMemo(
		() =>
			searchParams.get("code") ||
			searchParams.get("reservationCode") ||
			searchParams.get("orderId") ||
			searchParams.get("oid") ||
			stored?.reservationCode ||
			"",
		[searchParams, stored],
	);
	const barId = useMemo(
		() =>
			searchParams.get("barId") ||
			searchParams.get("clubId") ||
			stored?.barId ||
			"",
		[searchParams, stored],
	);

	useEffect(() => {
		let mounted = true;
		if (!reservationCode || !barId) {
			setStatusLoaded(true);
			return undefined;
		}
		getReservationStatusApi(barId, reservationCode)
			.then((response) => {
				if (mounted) setStatusInfo(response?.data?.info || null);
			})
			.catch(() => {})
			.finally(() => {
				if (mounted) setStatusLoaded(true);
			});
		return () => {
			mounted = false;
		};
	}, [barId, reservationCode]);

	const queryReservation = useMemo(
		() => ({
			flow: searchParams.get("flow"),
			durationMinutes: searchParams.get("durationMinutes"),
			sport: searchParams.get("sport"),
		}),
		[searchParams],
	);
	const reservationKind = getReservationKind({
		statusInfo,
		queryReservation,
		storedReservation: stored,
	});
	const isCourt = reservationKind === "court";
	const isBeauty = reservationKind === "beauty";
	const backToBarPath = isBeauty
		? barId
			? `/beauty/${barId}`
			: "/reservas"
		: isCourt
		? barId
			? `/canchas/${barId}`
			: "/canchas"
		: stored?.barSlugOrId
			? `/reservas/${stored.barSlugOrId}`
			: "/reservas";
	const copy = isBeauty
		? {
				title: "Turno cancelado",
				description:
					"El proceso de pago fue cancelado o interrumpido. Tu turno no fue confirmado. Podés intentarlo de nuevo cuando quieras.",
				backLabel: "Volver al salón",
				browseLabel: "Ir a Reservas",
			}
		: isCourt
		? {
				title: "Reserva de cancha cancelada",
				description:
					"El proceso de pago fue cancelado o interrumpido. Tu reserva de cancha no fue confirmada. Podés intentarlo de nuevo o explorar otras canchas.",
				backLabel: "Volver a la cancha",
				browseLabel: "Ver otras canchas",
			}
		: {
				title: "Reserva cancelada",
				description:
					"El proceso de pago fue cancelado o interrumpido. Tu reserva no fue confirmada. Podés intentarlo de nuevo o explorar otros bares.",
				backLabel: "Volver al bar",
				browseLabel: "Ver otros bares",
			};

	return (
		<div className="reservas-root">
			<div className="wrap">
				<div className="cancel-page">
					<div className="cic">
						<RIcon name="ban" width={36} height={36} />
					</div>
					<h1>{copy.title}</h1>
					<p>{copy.description}</p>
					{!statusLoaded && reservationCode && barId ? (
						<span className="spin" aria-label="Consultando reserva" />
					) : null}
					<div className="cancel-actions">
						<button
							className="r-btn-soft"
							style={{ padding: "13px 24px" }}
							onClick={() => navigate(backToBarPath)}
						>
							<RIcon name="chevL" width={16} height={16} /> {copy.backLabel}
						</button>
						<button
							className="r-btn-primary"
							style={{ padding: "13px 24px" }}
							onClick={() => navigate(isCourt ? "/canchas" : "/reservas")}
						>
							{copy.browseLabel}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ReservaCancel;
